import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import axios from 'axios';
import VueRouter from 'vue-router'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Store from './views/Store.vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(Vuex)


axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_URL;

Vue.config.productionTip = false

Vue.use(VueRouter)


const routes = [
    { path: '/', component: Store, name: 'store' },
]

const router = new VueRouter({mode: 'history', routes})

const store = new Vuex.Store({
    state: {
        accessToken: null,
    },
    mutations: {
        storeToken(state, token) {
          state.accessToken = token
        },
    },
    actions: {
      storeToken({commit}, token) {

          commit('storeToken', {
              access: token
            })
      }
    },
  getters: {
    getToken(state) {
        return state.accessToken
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
